import { Pickaxe } from "lucide-react";

import { MiningConfigPanel } from "@/components/admin/MiningConfigPanel";

export default function MiningConfig() {
  return (
    <main data-testid="admin-mining-config-page" className="min-h-screen bg-zinc-950 px-4 py-8 text-zinc-100 sm:px-8">
      <div className="mx-auto max-w-7xl">
        <header className="mb-8">
          <div className="mb-2 flex items-center gap-3 text-amber-300"><Pickaxe size={28} /><span className="text-xs uppercase tracking-[0.2em]">Administration</span></div>
          <h1 className="font-cinzel text-4xl text-amber-300">Mining Controls</h1>
          <p className="mt-2 text-sm text-zinc-400">Separate mining balancing controls for deposits, smelting, smithing materials, and pickaxe economy.</p>
        </header>

        <MiningConfigPanel />
      </div>
    </main>
  );
}